import { create } from 'zustand'
import { PageMode, DigitalHumanMode, HomePlaceInfo, EventCardInfo, CharacterRoutePlaceInfo, ThemeRoutePlaceInfo, LandmarkPoetryPlaceInfo, LandmarkPoetryPlaceDetailType, PoetryLoadProgress } from './types'



export type Store = {
  // 展项级配置
  mode: PageMode
  setMode: (mode: PageMode) => void

  // 数字人配置
  digitalHumanMode: DigitalHumanMode
  // setDigitalHumanMode: (mode: DigitalHumanMode) => void
  toggleDigitalHumanMode: (
    mode?: DigitalHumanMode
  ) => void

  // 首页配置
  homePlaceId: string | null
  setHomeMode: (placeId?:string) => void

  // 大事件配置
  eventCardId: string | null
  eventDynastyRange: [string|null, string|null,string|null,string|null] | null
  setEventCardMode: (id:string|null, dynastyRange:[string|null, string|null,string|null,string|null]|null) => void
  setEventCardId: (id:string|null) => void

  // 地标诗词配置
  landmarkPoetryPlaceType: LandmarkPoetryPlaceDetailType | null
  landmarkPoetryPlaceId: string | null
  landmarkPoetryPlaceAuthor: string | null
  setLandmarkPoetryMode: (placeId?:string,type?:LandmarkPoetryPlaceDetailType,author?:string) => void

  // 诗词地标数据加载进度（全局 loading 用）
  poetryProgress: PoetryLoadProgress | null
  setPoetryProgress: (progress: PoetryLoadProgress | null) => void

  // 主题游线配置
  // themeRoutePlaceDetail: ThemeRoutePlaceInfo | null
  // setThemeRoutePlaceDetail: (place: ThemeRoutePlaceInfo | null) => void

  // 人物游线配置

  // 时间轴路线id  4a633e8d-4652-4e77-a1aa-e586c621fbef
  routeTimeLineDetailId: string | null;
  setRouteTimeLineDetailId: (id: string | null) => void

  // 人物游线轨迹单个
  routeDetailId: string | null;
  setRouteDetailMode: (id: string) => void
}

// 所有弹框初始化数据
const initDetailState = {
  homePlaceId: null,
  eventCardId: null,
  eventDynastyRange: null,
  landmarkPoetryPlaceType: null,
  landmarkPoetryPlaceId: null,
  landmarkPoetryPlaceAuthor: null,
  routeTimeLineDetailId: null,
  routeDetailId: null,
}

export const useStore = create<Store>()((set) => ({
  // 展项级配置
  mode: PageMode.SILENT,
  setMode: (mode) => set({ mode, ...initDetailState }), // 模式切换时，关闭所有弹框
  digitalHumanMode: DigitalHumanMode.CORNER,

  // 数字人配置
  // setDigitalHumanMode: (mode) => set({ digitalHumanMode: mode }),
  toggleDigitalHumanMode: (mode) => set((state) => {
    const v = mode || (state.digitalHumanMode === DigitalHumanMode.CORNER
    ? DigitalHumanMode.FULLSCREEN
    : DigitalHumanMode.CORNER)

    return {
      digitalHumanMode: v,
    }
  }),

  // 首页配置
  homePlaceId: null,
  setHomeMode: (placeId) => set({ ...initDetailState,mode: PageMode.HOME, homePlaceId: placeId||null }),


  // 大事件配置
  eventCardId: null,
  eventDynastyRange: null,
  setEventCardMode: (id, dynastyRange) => set((state)=>{
    if(id&&!dynastyRange){
      return { ...initDetailState,mode: PageMode.EVENT, eventCardId: id||null, eventDynastyRange: state.eventDynastyRange }
    }else{
      return { ...initDetailState,mode: PageMode.EVENT, eventCardId: id||null, eventDynastyRange: dynastyRange||null }
    }
  }),

  setEventCardId: (id) => set({ eventCardId: id||null }),

  // 地标诗词配置
  landmarkPoetryPlaceType: null,
  landmarkPoetryPlaceId: null,
  landmarkPoetryPlaceAuthor: null,
  setLandmarkPoetryMode: (placeId?:string,type?:LandmarkPoetryPlaceDetailType,author?:string) => set({
    ...initDetailState,
    mode: PageMode.LANDMARK_POETRY,
    landmarkPoetryPlaceId: placeId||null,
    landmarkPoetryPlaceType: type||null,
    landmarkPoetryPlaceAuthor: author||null,
   }),

  // 诗词地标数据加载进度
  poetryProgress: null,
  setPoetryProgress: (progress) => set({ poetryProgress: progress }),


  // 路线详情id
  routeTimeLineDetailId: null,
  setRouteTimeLineDetailId: (id) => set({ routeTimeLineDetailId: id }),


  // 人物游线轨迹单个
  routeDetailId: null,
  setRouteDetailMode: (id) => set({...initDetailState, mode: PageMode.ROUTE_CHARACTER_TRACK_SINGLE, routeDetailId: id }),
}))


export function getStore() {
  return useStore.getState()
}

